
import axios from 'axios'

export const getEmailTemplateData = async(organizationId, programId, eventTypeId) => {
    const response = await axios.get(`/organization/${organizationId}/program/${programId}/eventType/${eventTypeId}/emailtemplatejson`)
    return response.data
}


export const getEventEmailTemplateData = async(organizationId, programId, eventId) => {
    const response = await axios.get(`/organization/${organizationId}/program/${programId}/event/${eventId}/emailtemplatejson`)
    return response.data
}